<template>
  <div class="RealisationProcessStatus">
    <h4 class="pb-1">
      {{ $t('RealisationProcessStatus.statusOfRealization') }}
    </h4>

    <GChart
      v-if="isDataLoaded"
      type="BarChart"
      :data="chartDataTable"
      :options="chartOptions"
      style="transform: scale(0.9, 0.9) translateY(-2em)"
    />
    <div
      v-else
      class="ml-3 mt-1"
    >
      Geladen <strong>{{ getCounts.current }}</strong> van totaal <strong>{{ getCounts.total }}</strong> realisatieprocessen.
    </div>
  </div>
</template>

<script>
import { GChart } from 'vue-google-charts';
import { mapGetters, mapActions } from 'vuex';

export default {
  name: 'RealisationProcessStatus',
  components: {
    GChart
  },
  data () {
    return {
      isDataLoaded: false,
      project: {
        _id: 0,
        case: 1,
        MunicipalityCode: 1,
        flow: 1,
        category: 1,
        address: '$process.Location.FullAddress',
        after: 1,
        GridOperator: '$process.GridOperator',
        Contractor: '$process.Contractor',
        NumberOfChargingStations: '$process.ParkingSpots.NumberOfChargingStations',
        processStatus: '$processStatus.status',
        status: 1,
        statusMeta: 1,
        uuid: 1,
        count: 1
        //Events: 1
      }
    }
  },
  computed: {
    ...mapGetters('realisations', ['records', 'getCounts', 'getReportingRecords']),
    ...mapGetters('tenant', ['getWorkflowSpecByName', 'getOnHoldReasons', 'getCancelReasons', 'getSteps']),

    /**
     * Bar chart visualisation options
     */
    chartOptions() {
      return {
        // layout
        height: 1100,
        width: 1800,
        chartArea: { left: 400, top: 10, right: 20, bottom: 0 },

        // other
        isStacked: false,
        legend: { position: 'bottom' },

        // axes
        hAxis: {
          title: ''
        },

        annotations: {
          textStyle: {
            color: 'black'
          },
          alwaysOutside: true,
          stem: {
            color: 'transparent'
          }
        }
        // orientation

        // TODO: Apply stack colors
        // series: {
        //   0: { color: 'green' },
        //   1: { color: 'blue' },
        //   // etc.
        // }
      };
    },

    steps() {
      //let spec = this.getWorkflowSpecByName({ name: 'realisation' });
      return this.getSteps //spec ? spec.steps : [];
    },

    /**
     *
     */
    availableSteps() {
      return this.steps.map(step => {
        return {
          value: step.uuid,
          label: `${step.short || step.step}: ${step.label[this.$i18n.locale] || step.label}`,
          count: 0
        };
      });
    },

    availableOnHoldStates() {
      return this.getOnHoldReasons.map(reason => {
        return {
          value: reason.value,
          label: `On hold: ${reason.text}`,
          count: 0
        };
      });
    },
    availableCancelStates() {
      return [
        {
          value: 'municipality-feedback',
          label: `${this.$i18n.t('processStatus.cancelled')}: ${this.$i18n.t('processes.statusFilters.municipality')} feedback`,
          count: 0
        }
      ].concat(
        this.getCancelReasons.map(reason => {
          return {
            value: reason.value,
            label: `${this.$i18n.t('processStatus.cancelled')}: ${reason.text}`,
            count: 0
          };
        })
      );
    },

    chartDataTableHeaderRow() {
      // steps, on hold reasons, cancelled reasons, afgerond

      // Status options, obtained from the tenant config.
      // let stepLabels = steps.map(step => `${step.short || step.step}: ${step.label}`)
      // let onHoldLabels = this.availableOnHoldStates.map(reason => reason.text)
      // let cancelLabels = this.availableCancelStates.map(reason => reason.text)

      // // Each status option is a data column in the data table
      // let headerRow = stepLabels.concat(onHoldLabels).concat(cancelLabels)
      // headerRow.push('Afgerond')

      // TODO: Add columns to subdivide "aantal" into count per # location proposals
      return ['Status',
       this.$t('RealisationProcessStatus.numberOfProcesses'), { role: 'annotation' },
       this.$t('RealisationProcessStatus.numberOfChargingStations'), { role: 'annotation' }];
    },

    /**
     * The data for rending a graph is provided in table format
     *  For a bar chart, the first row in the datatable constains the labels,
     *  but also the role of the column in the datatable. This is not to be confused with the actual bars.
     */
    chartDataTable() {
      let RecordsByStep = {};
      let RecordsByCancelReason = {};
      let RecordsByOnHoldReason = {};
      let RecordsCompleted = 0;
      // eslint-disable-next-line no-unused-vars
      let unknown = 0;

      let RecordsCompletedChargerCount = 0;
      let unknownChargerCount = 0;

      this.getReportingRecords.forEach(record => {
        let status = record.status;
        let meta = record.statusMeta;

        let NumberOfChargingStations = Number(record.NumberOfChargingStations) || 0

        if (status.completed) {
          RecordsCompleted++;
          RecordsCompletedChargerCount = RecordsCompletedChargerCount + NumberOfChargingStations;
        } else if (status.cancelled) {
          let reason = meta.cancelled.reason || 'unknown';
          RecordsByCancelReason[reason] = RecordsByCancelReason[reason] || 0;
          RecordsByCancelReason[reason]++;
          RecordsByCancelReason[reason + '-chargerCount'] =
            (RecordsByCancelReason[reason + '-chargerCount'] || 0) + NumberOfChargingStations;
        } else if (status.onhold) {
          let reason = meta.onhold.reason || 'unknown';
          RecordsByOnHoldReason[reason] = RecordsByOnHoldReason[reason] || 0;
          RecordsByOnHoldReason[reason]++;
          RecordsByOnHoldReason[reason + '-chargerCount'] =
            (RecordsByOnHoldReason[reason + '-chargerCount'] || 0) + NumberOfChargingStations;
        } else if (status.uuid) {
          RecordsByStep[status.uuid] = RecordsByStep[status.uuid] || 0;
          RecordsByStep[status.uuid]++;
          RecordsByStep[status.uuid + '-chargerCount'] =
            (RecordsByStep[status.uuid + '-chargerCount'] || 0) + NumberOfChargingStations;
        } else {
          unknown++;
          unknownChargerCount = unknownChargerCount + NumberOfChargingStations;
        }
      });

      // console.log(
      //   RecordsByStep,
      //   RecordsByCancelReason,
      //   RecordsByOnHoldReason,
      //   RecordsCompleted
      // )

      // Set the header row as first row in our data table
      const headerRow = this.chartDataTableHeaderRow;
      let chartDataTable = [headerRow];

      this.availableSteps.forEach(state => {
        let row = [state.label];
        row.push(RecordsByStep[state.value] || 0);
        row.push(RecordsByStep[state.value] || 0);
        row.push(RecordsByStep[state.value + '-chargerCount'] || 0);
        row.push(RecordsByStep[state.value + '-chargerCount'] || 0);
        chartDataTable.push(row);
      });

      this.availableCancelStates.forEach(state => {
        let row = [state.label];
        row.push(RecordsByCancelReason[state.value] || 0);
        row.push(RecordsByCancelReason[state.value] || 0);
        row.push(RecordsByCancelReason[state.value + '-chargerCount'] || 0);
        row.push(RecordsByCancelReason[state.value + '-chargerCount'] || 0);
        chartDataTable.push(row);
      });

      this.availableOnHoldStates.forEach(state => {
        let row = [state.label];
        row.push(RecordsByOnHoldReason[state.value] || 0);
        row.push(RecordsByOnHoldReason[state.value] || 0);
        row.push(RecordsByOnHoldReason[state.value + '-chargerCount'] || 0);
        row.push(RecordsByOnHoldReason[state.value + '-chargerCount'] || 0);
        chartDataTable.push(row);
      });

      chartDataTable.push([
        `${this.$i18n.t('processStatus.completed')}`,
        RecordsCompleted,
        RecordsCompleted,
        RecordsCompletedChargerCount,
        RecordsCompletedChargerCount
      ]);

      //console.log('Records with unknown status', unknown, unknownChargerCount);

      return chartDataTable;
    }
  },
  async created () {
    if (!this.getReportingRecords.length) {
      this.isDataLoaded = false;
      const token = await this.$auth.getTokenSilently();
      await this.loadRecords({ token, reporting: true, limit: 1000, project: this.project }).catch(err => console.log(err))
    }

    this.isDataLoaded = true;
  },
  methods: {
    ...mapActions('realisations', ['loadRecords']),
  }
};
</script>

<style></style>
